import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=52556ef1&scoped=true&"
import script from "./teaser.vue?vue&type=script&lang=js&"
export * from "./teaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52556ef1",
  null
  
)

export default component.exports